/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EmergencyCaseDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: EmergencyCaseDefinitionDto.source;
    label?: string;
}

export namespace EmergencyCaseDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
